import Vue from 'vue';
import Vuex from 'vuex';
import analyze from '@/store/modules/analyze';
import analyzeMap from '@/store/modules/analyzeMap';
import filters from '@/store/modules/filters';
import loader from '@/store/modules/loader';
import loadingSpinners from '@/store/modules/loadingSpinners';
import mapImageData from '@/store/modules/mapImageData';
import nav from '@/store/modules/nav';
import nearestStations from '@/store/modules/nearestStations';
import routeStations from '@/store/modules/routeStations';
import stationDetails from '@/store/modules/stationDetails';
import stationPoints from '@/store/modules/stationPoints';
import corridors from '@/store/modules/corridors';

Vue.use(Vuex);

const debug = (process.env.NODE_ENV !== 'production');

export default new Vuex.Store({
  strict: debug,

  modules: {
    analyze,
    analyzeMap,
    filters,
    loader,
    loadingSpinners,
    mapImageData,
    nav,
    nearestStations,
    routeStations,
    stationDetails,
    stationPoints,
    corridors,
  },
});
